import React,{useEffect} from 'react'
import '../css/admin.lite.scss'
import { Layout, Typography, Row, Col, Space, Card, Tag, Spin, Badge } from 'antd'
import {
  LogoutOutlined,
  MessageOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'
import { connect } from 'react-redux'
import { capitalize, isEmpty } from 'lodash'
import util from '../../util/util'
import { getPatientMessages, setSingleMsg ,setPatientAndMsg,updateLastViewed} from '../../store/action/actioncases.action'
import {
  deleteUserDeviceToken,
  logout,
} from '../../store/action/profile.action'
import { useHistory, Redirect } from 'react-router-dom'
import { constants } from '../../constants'
const { Content } = Layout

const MessagesListing = (props) => {
  var history = useHistory()

    useEffect(() => {
      fetchMessages()
    }, [])

    const fetchMessages = async () => {
      try {
        const filter = {
          customerIds: props?.customer?._id
            ? [props.customer._id]
            : [props?.decoded?.customer],
        }
  
        if (props.user?.role === constants.ROLE.SURGEON || props.user?.surgeon) {
          filter.surgeonId = props.user?.surgeon
        }
  
        const data = await props.getPatientMessages({
          filters: filter,
          sorter: { field: 'lastUpdated', order: 'descend' },
        })
  
        return data
      } catch (err) {
        console.log(err, 'Error')
      }
    }  

    const handleNavigate=async(path,pathName)=>{

      await history.push({ pathname:pathName, search: constants.ADMIN_LITE })
      if(!window.ReactNativeWebView)return;
        await window.ReactNativeWebView.postMessage(
        JSON.stringify({
          route: '/navigate',
          data: { path },
        })
      )
     
    }
    const handlePatinetMessage = async(data) => {
      if (data.messages?.length <= 1) {
        let singlemessage = { ...data, message: data.messages[0] }
        console.log(singlemessage,"singlemessage")
        props.setSingleMsg(singlemessage)
        const path = `/message-interface${constants.ADMIN_LITE}`
        const pathName= '/message-interface'
        handleNavigate(path,pathName)
        // setPage(3)
        return
      }
     
      props.setPatientAndMsg(data)
      const path = `/patient-message${constants.ADMIN_LITE}`
      const pathName= '/patient-message'
      handleNavigate(path,pathName)
      // setPage(2)
    }

    const handleLogout = async () => {
      try {
        await props.deleteUserDeviceToken()
        await props.logoutapp()
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ route: '/logout' })
        )
      
      } catch (err) {
        console.log(err, 'Error in logout')
      }
    }

  const Header = () => {
    return (
      <div className='header'>
        <Row justify='space-between' align='middle'>
          <Col span={24}>
          <Row justify='space-between' align='middle' >
            <Col> <Typography.Title level={4}>Patient Messages</Typography.Title></Col>
            <Col> <div className='logout-link' onClick={handleLogout}>LOGOUT</div></Col>
          </Row>
           
            <Typography.Text type='secondary' style={{ fontSize: '16px' }}>
              Logged in as:{' '}
              {props.user?.firstname + ' ' + (props.user?.lastname || '')}
            </Typography.Text>
          </Col>
        </Row>
      </div>
    )
  }
const Banner = () => {
    const hasLogo = !!props.customer?.logo;
    const nameFontSize = hasLogo ? 14 : 18;

    return (
      <div className="banner-head">
        {hasLogo && (
          <Col
            span={24}
            flex={'none'}
            className='customerLogo'
            style={{ maxHeight: 'fit-content' }}
          >
            <img src={props.customer.logo} alt="Clinic Logo" />
          </Col>
        )}
        <Row justify='space-between' align='middle' style={{ marginTop: '8px' }}>
          <Col style={{ flex: 1 }}>
            <Typography.Text 
              className='banner' 
              style={{ 
                fontSize: nameFontSize, 
              }}
            >
              {props.customer?.name}
            </Typography.Text>
          </Col>
          <Col>
            <Typography.Text  className='banner'  style={{ textAlign: 'end' }}>
              Code:{" "} {props.customer?.accesscode}
            </Typography.Text>
          </Col>
        </Row>
      </div>
    )
  }
  const PatientCard = (data) => {
    return (
      <Card
        className='admin-lite patient-card'
        bordered={false}
        onClick={() => handlePatinetMessage(data)}
      >
        <Typography.Text strong>
          {capitalize(data.patient?.firstname) +
            ' ' +
            capitalize(data.patient?.lastname)}
        </Typography.Text>

      {data.isNewCount > 0 && (
        <div className='custom-badge'> <Badge count={data.isNewCount} /></div>

    )}
        {/* {data.isNewCount == 0 && (
          <div className='message-status'>
            <Space>
              <MessageOutlined />
              <Typography.Text type='secondary'>
                No new messages
              </Typography.Text>
            </Space>
          </div>
        )} */}

        {/* {data.isNewCount != 0 && (
          <div className='new-message'>
            <Space>
              <InfoCircleOutlined style={{ color: '#1890ff' }} />
              <Typography.Text type='link'>
                {data?.isNewCount} new message{data.isNewCount > 1 ? 's' : ''}
              </Typography.Text>
            </Space>
          </div>
        )} */}

        <div className='tags'>
          <Space wrap>
            <Tag color={'blue'}>{data?.patient?.surgeon?.name}</Tag>
            {/* {teams.map((t,i)=>(
                      <Tag color='green' key={i}>
                      {t || 'NA'} (admin)
                    </Tag>
             ))} */}
          </Space>
        </div>
      </Card>
    )
  }

  return (
    <div className='message-pages'>
     <Spin spinning={props.isLoading}>
    <Layout className='layout'>
      <Content className='content-listing'>
        <Banner/>
        <Header />
 
        <div className='messages'>
          {props.msgList.map((msg, index) => (
            <PatientCard key={msg?.patient?._id} {...msg} />
          ))}
        </div>
      </Content>
    </Layout>
    </Spin> 
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    decoded: util.verifyToken(state.profile.token, true),
    isLoading: state.actioncase.isLoading,
    customer: state.profile.customer,
    user: state.profile.user,
    currentUserRole: state.profile?.user?.role,
    msgList: state.actioncase.msgList,
    total: state.actioncase.total,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getPatientMessages: (params) => dispatch(getPatientMessages(params)),
    logoutapp: () => dispatch(logout()),
    updateLastViewed: (params) => dispatch(updateLastViewed(params)),
    deleteUserDeviceToken: (params) => dispatch(deleteUserDeviceToken(params)),
    setSingleMsg: (params) => dispatch(setSingleMsg(params)),
    setPatientAndMsg: (params) => dispatch(setPatientAndMsg(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesListing)
